import { useSyncExternalStore } from 'react';
import {
  isSessionDebugModeEnabled,
  SESSION_DEBUG_MODE_CHANGED_EVENT,
} from '../../constants/sessionDebugMode';

function subscribe(onStoreChange: () => void) {
  if (typeof window === 'undefined') {
    return () => {};
  }
  const listener = () => onStoreChange();
  window.addEventListener(SESSION_DEBUG_MODE_CHANGED_EVENT, listener);
  return () => window.removeEventListener(SESSION_DEBUG_MODE_CHANGED_EVENT, listener);
}

function getSnapshot() {
  return isSessionDebugModeEnabled();
}

/** True when Help-chat debug mode is on for this tab (`sessionStorage`). */
export function useSessionDebugMode(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
